import { string, object } from 'yup';

export const VerificationValidationSchema = object({
    verificationCode: string().required('Bitte geben Sie einen gültigen Verifizierungscode ein.')
})